<template>
  <component
    :is="tag"
    class="dropdown"
    :class="{ show: isOpen }"
    @click.stop="toggleDropDown"
  >
    <a
      class="dropdown-toggle btn-rotate"
      :class="titleClasses"
      data-toggle="dropdown"
    >
      <slot name="title">
        <i :class="icon"></i>
        <span class="notification">
          {{ title }}
          <b class="caret"></b>
        </span>
      </slot>
    </a>
    <ul
      class="v-dropdown-menu"
      :class="{ show: isOpen }"
      v-if="isOpen"
      @click.stop
    >
      <slot></slot>
    </ul>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "li",
    },
    title: String,
    icon: String,
    titleClasses: [String, Object, Array],
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleDropDown() {
      this.$emit("change");
    },
  },
};
</script>

<style scoped>
.v-dropdown-menu {
  position: relative;
  transform: translate3d(0px, 0px, 0px);
  visibility: visible !important;
  z-index: 1000;
  margin-top: 12px;
}

.dropdown-link:hover {
  background-color: #23282d;
}
</style>
